import React from "react";
import styled from "styled-components";
import BotagActionImage from "../../../assets/images/botag-action.svg";

// #region BOTagOverProductCard CSS
const BOTagOverProductCardDiv = styled.div`
    &.BOTagOverProductCard {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #141922cc;
        z-index: 9;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .close-botag-over-product-card {
        position: absolute;
        height: 32px;
        width: 32px;
        background: #000;
        border-radius: 50px;
        justify-content: center;
        display: flex;
        align-items: center;
        top: 17px;
        right: 17px;
        cursor: pointer;
    }
    .botag-main-container {
        height: 328px;
        width: 232px;
        background: #121212;
        border-radius: 10px;
        position: absolute;
        left: 25px;
    }
    .frame-313504 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313326 {
        padding: 15px 15px 0px 15px;
        display: flex;
        flex-direction: row;
        gap: 14px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313322 {
        display: flex;
        flex-direction: row;
        gap: 14px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .luan-j-shirt-cosmic-4-1 {
        border-radius: 5px;
        flex-shrink: 0;
        width: 56px;
        height: 74px;
        position: relative;
        object-fit: cover;
    }
    .frame-313314 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 76px;
        position: relative;
    }
    .frame-313317 {
        display: flex;
        flex-direction: column;
        gap: 7px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313316 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .replay-top {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        height: 14px;
    }
    .original-t-skjorte {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        font-weight: 600;
        position: relative;
        width: 134px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .frame-313313 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .group-3555 {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: static;
    }
    .ellipse-12 {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 50%;
        width: 28.12%;
        height: 100%;
        position: absolute;
        right: 71.88%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .m {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: absolute;
        right: 74.22%;
        left: 2.34%;
        width: 23.44%;
        bottom: 25.6%;
        top: 23.02%;
        height: 51.39%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .group-3556 {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: static;
    }
    .color-circle {
        width: 28.12%;
        height: 100%;
        position: absolute;
        right: 35.94%;
        left: 35.94%;
        bottom: 0%;
        top: 0%;
    }
    .ellipse-122 {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .image-44 {
        background: var(--text-and-icons-red-500, #ff3636);
        border-radius: 50px;
        width: 26.56%;
        height: 94.44%;
        position: absolute;
        right: 36.72%;
        left: 36.72%;
        bottom: 2.78%;
        top: 2.78%;
    }
    .group-3554 {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: static;
    }
    .ellipse-123 {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 50%;
        width: 28.12%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 71.88%;
        bottom: 0%;
        top: 0%;
    }
    ._1 {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: absolute;
        right: 2.34%;
        left: 74.22%;
        width: 23.44%;
        bottom: 25.6%;
        top: 23.02%;
        height: 51.39%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-313318 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .line-26 {
        margin-top: -0.5px;
        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0.001deg) scale(1, 1);
    }
    .frame-313319 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .div {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 10px;
        font-weight: 400;
        position: relative;
    }
    .line-25 {
        margin-top: -0.5px;
        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0.001deg) scale(1, 1);
    }
    .frame-313504-actions-main {
        height: 192px;
        width: 232px;
        display: flex;
        gap: 13.5px;
        flex-direction: column;
    }
    .pick-cour-cta {
        height: 145.5px;
        width: 100%;
        display: flex;
        flex-direction: row;
    }
    .frame-cour-cta {
        display: flex;
        height: 145.5px;
        width: 232px;
        flex-direction: column;
        gap: 13px;
    }
    .frrame-courier-cta-group {
        height: 87px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
    }
    .group-buuton-cta {
        height: 45px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: space-between;
    }
    .gropu-courier-option {
        height: 61px;
        display: flex;
        flex-direction: column;
        gap: 7px;
        align-items: center;
    }
    .groupbutton-cta-courier {
        height: 38px;
        display: flex;
        align-items: center;
        width: 232px;
        justify-content: center;
    }
    .pick-up {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: center;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .botag-btn-container {
        width: 202px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #212121;
        border-radius: 5px;
    }
    .botag-btn-container.transparent-bg {
        gap: 10px !important;
        background-color: transparent !important;
    }
    .pick-up.new-btn {
        background-color: rgb(33, 33, 33) !important;
        border-radius: 5px !important;
    }

    .frame-29287 {
        flex-shrink: 0;
        width: 26px;
        height: 122px;
        position: relative;
        bottom: 11px;
        right: 1px;
    }
    .rectangle-253 {
        border-radius: 0px;
        width: 26px;
        height: 122px;
        position: absolute;
        left: 0px;
        top: 0px;
        overflow: visible;
    }
`;
// #endregion

export default function BOTagOverProductCard({ onClose, data, selectedColor, selectedSize, visible, style }) {
    if (!visible) return <></>;

    return (
        <BOTagOverProductCardDiv className="BOTagOverProductCard" style={style}>
            <div className="close-botag-over-product-card" onClick={onClose}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FF2A2A"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </div>
            <div className="botag-main-container">
                <div className="frame-313504">
                    <div className="frame-313326">
                        <div className="frame-313322">
                            <img className="luan-j-shirt-cosmic-4-1" src={data?.image} alt={data?.styleName} />
                            <div className="frame-313314">
                                <div className="frame-313317">
                                    <div className="frame-313316">
                                        <div className="replay-top">
                                            {data?.brand} / {data?.category}{" "}
                                        </div>
                                        <div className="original-t-skjorte">{data?.styleName}</div>
                                    </div>
                                    <div className="frame-313313">
                                        <div className="group-3555">
                                            <div className="ellipse-12"></div>
                                            <div
                                                className="m"
                                                style={{
                                                    fontSize: selectedSize?.length > 3 ? "10px" : "12px"
                                                }}>
                                                {selectedSize}
                                            </div>
                                        </div>
                                        <div className="group-3556">
                                            <div className="color-circle">
                                                <div className="ellipse-122"></div>
                                            </div>
                                            <div className="image-44" style={{ background: `#${selectedColor}` }}></div>
                                        </div>
                                        <div className="group-3554">
                                            <div className="ellipse-123"></div>
                                            <div className="_1">1</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="frame-313318">
                        <div className="line-26"></div>
                        <div className="frame-313319">
                            <div className="div">-</div>
                        </div>
                        <div className="line-25"></div>
                    </div>
                </div>
                <div className="frame-313504-actions-main">
                    <div className="pick-cour-cta">
                        <div className="frame-cour-cta">
                            <div className="frrame-courier-cta-group">
                                <div className="gropu-courier-option">
                                    <div className="groupbutton-cta-courier">
                                        <div className="botag-btn-container">
                                            <div className="pick-up">Pick-up</div>
                                            <div className="pick-up">Courier</div>
                                            <div className="pick-up">Shipping</div>
                                        </div>
                                    </div>
                                    <div className="frame-313319">
                                        <div className="div">-</div>
                                    </div>
                                </div>
                                <div className="frame-313319">
                                    <div className="div">-</div>
                                </div>
                            </div>
                            <div className="group-buuton-cta">
                                <div className="frame-313318">
                                    <div className="line-26"></div>
                                    <div className="frame-313319">
                                        <div className="div">-</div>
                                    </div>
                                    <div className="line-25"></div>
                                </div>
                                <div className="frame-313319">
                                    <div className="div">-</div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-29287">
                            <img className="rectangle-253" src={BotagActionImage} alt="rectangle-2530.svg" />
                        </div>
                    </div>
                    <div className="group-buuton-cta">
                        <div className="botag-btn-container transparent-bg">
                            <div className="pick-up new-btn">Add to bag</div>
                            <div className="pick-up new-btn">Buy now</div>
                        </div>
                    </div>
                </div>
            </div>
        </BOTagOverProductCardDiv>
    );
}
